import videoUtils from './videoUtils';
import imageUtils from './imageUtils';
import reporter from '../reporter';
import {generateError} from '../validations/errors';
import isNil from 'lodash/isNil';
import assign from 'lodash/assign';



function getMediaDataFromSrc(value){
    let mediaData;
    if (videoUtils.isVideoUrl(value)){
        mediaData = videoUtils.extractModelDataFromSrc(value);
        if (mediaData) {
           assign(mediaData, {type: 'WixVideo'});
        }
    } else {
        mediaData = imageUtils.extractModelDataFromSrc(value);
        if (mediaData) {
            assign(mediaData, {type: 'Image'});
        }
    }
    if (!isNil(value) && !mediaData) {
        reporter.reportSdkError(generateError.error_bad_background_format({
            propertyName: 'src',
            functionName: 'background',
            wrongValue: value
        }));
        return null;
    }
    return mediaData || {};
}

function getFullMediaData(mediaData, callback) {
    if (mediaData.videoId) {
        videoUtils.getFullVideoData(mediaData.videoId, callback);
        return;
    }
    callback();
}

function buildFullUrlFromMediaRef(mediaData) {
    if (mediaData.videoId) {
        return videoUtils.buildFullUrlFromMediaRef(mediaData);
    }
    return imageUtils.buildFullUrlFromMediaRef(mediaData);
}


export default {
    buildFullUrlFromMediaRef,
    getMediaDataFromSrc,
    getFullMediaData
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils/mediaUtils.es6